/* eslint-disable */
import type { CardScheme, CashDrawerData, IssuedCard, RoundUpsData } from "../common.pb";
import type { Region } from "../region.pb";
import type { ScenarioPlanEntry } from "./payment.pb";

export interface UiIssuedCard {
  issued_card?: IssuedCard;
  cash_drawer_data?: CashDrawerData;
  mode?: UiIssuedCardMode;
  card_scheme?: CardScheme;
  round_ups_data?: RoundUpsData;
  initial_blocker_data?: InitialBlockerData;
  card_order_data?: CardOrderData;
  customer_data?: CustomerData;
}

/**
 * The mode of this issued card representation for display - "NULL_STATE" implies we should show
 * the null-state animation, "NORMAL" implies we should show the contents of this UiIssuedCard.
 */
export enum UiIssuedCardMode {
  NULL_STATE = "NULL_STATE",
  NORMAL = "NORMAL",
}

export interface InitialBlockerData {
  scenario_plan_entries?: ScenarioPlanEntry[];
}

export interface CardOrderData {
  state?: CardOrderDataState;
  state_reason?: CardOrderDataStateReason;
  state_transitioned_at?: number;
  issued_at?: number;
  flow_type?: string;
  last_card_ordered_at?: number;
  name_on_card?: string;
  card_theme_token?: string;
}

export enum CardOrderDataState {
  DRAFT = "DRAFT",
  PENDING_SUBMISSION = "PENDING_SUBMISSION",
  PENDING_REVIEW = "PENDING_REVIEW",
  PENDING_ISSUE = "PENDING_ISSUE",
  ISSUED = "ISSUED",
  SUSPENDED = "SUSPENDED",
  SHIPPED = "SHIPPED",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
  OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY",
}

export enum CardOrderDataStateReason {
  ORDER_INITIATED = "ORDER_INITIATED",
  SPONSORSHIP_REQUESTED = "SPONSORSHIP_REQUESTED",
  ORDER_SUBMITTED = "ORDER_SUBMITTED",
  REVIEW_DECLINED = "REVIEW_DECLINED",
  REVIEW_APPROVED = "REVIEW_APPROVED",
  SPONSORSHIP_CANCELED = "SPONSORSHIP_CANCELED",
  ORDER_REJECTED = "ORDER_REJECTED",
  MANUAL_INTERVENTION_RESOLVED = "MANUAL_INTERVENTION_RESOLVED",
  MAILING_ADDRESS_AMENDED = "MAILING_ADDRESS_AMENDED",
  CARD_UNDELIVERABLE = "CARD_UNDELIVERABLE",
  MANUAL_INTERVENTION = "MANUAL_INTERVENTION",
  SUSPENDED_TOO_LONG_TIME = "SUSPENDED_TOO_LONG_TIME",
  CARD_ISSUED = "CARD_ISSUED",
  CARD_SHIPPED = "CARD_SHIPPED",
  CARD_DELIVERED = "CARD_DELIVERED",
  ORDER_UNLINKED = "ORDER_UNLINKED",
  RISK_REVIEW_DECLINED = "RISK_REVIEW_DECLINED",
  VIRTUAL_CARD_ACTIVATION_FAILED = "VIRTUAL_CARD_ACTIVATION_FAILED",
  OTHER_FAILURE = "OTHER_FAILURE",
  CARD_REISSUED = "CARD_REISSUED",
  CARD_OUT_FOR_DELIVERY = "CARD_OUT_FOR_DELIVERY",
  IDV_REVIEW_PENDING = "IDV_REVIEW_PENDING",
  IDV_REVIEW_FAILED = "IDV_REVIEW_FAILED",
}

export interface CustomerData {
  state?: CustomerDataState;
  region?: Region;
  idv_status?: CustomerDataIDVStatus;
  has_passcode?: boolean;
  /** for initial blocker */
  security_lock_enabled?: boolean;
  cashtag?: string;
  joined_at?: number;
}

export enum CustomerDataState {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  DENYLISTED = "DENYLISTED",
  SUSPENDED = "SUSPENDED",
}

export interface CustomerDataIDVStatus {
  status?: CustomerDataIDVStatusVerificationStatus;
  can_attempt_electronic_idv_at?: number;
}

export enum CustomerDataIDVStatusVerificationStatus {
  VERIFICATION_UNKNOWN = "VERIFICATION_UNKNOWN",
  NOT_VERIFIED = "NOT_VERIFIED",
  IN_REVIEW = "IN_REVIEW",
  VERIFIED = "VERIFIED",
  SPONSORSHIP_ACTIVE = "SPONSORSHIP_ACTIVE",
  SPONSORSHIP_PENDING = "SPONSORSHIP_PENDING",
  SPONSORSHIP_SUSPENDED = "SPONSORSHIP_SUSPENDED",
  SPONSORSHIP_CANCELED = "SPONSORSHIP_CANCELED",
}
